import { useEffect } from 'react';

export default function Privacy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-black pt-32 pb-20 px-4 sm:px-6">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Política de Privacidade</h1>
                <div className="text-gray-300 space-y-6 leading-relaxed">

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">1. Recolha de Dados</h2>
                        <p>Recolhemos apenas as informações necessárias ao processamento da sua encomenda: endereço de e-mail e informações de pagamento (processadas pelos nossos prestadores seguros). Não conservamos os seus dados bancários.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">2. Utilização dos Dados</h2>
                        <p>Os seus dados são utilizados para:</p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Enviar-lhe as suas credenciais de ligação.</li>
                            <li>Fornecer-lhe suporte técnico.</li>
                            <li>Informá-lo sobre atualizações importantes do serviço.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">3. Proteção dos Dados</h2>
                        <p>Implementamos medidas de segurança técnicas para proteger as suas informações pessoais contra acesso não autorizado. Os seus dados nunca são vendidos a terceiros.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">4. Cookies</h2>
                        <p>O nosso site utiliza cookies essenciais para o funcionamento do carrinho de compras e análise anónima do tráfego para melhorar a sua experiência.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">5. Os Seus Direitos</h2>
                        <p>De acordo com o RGPD, tem direito de acesso, retificação e eliminação dos seus dados. Para exercer este direito, contacte-nos em support@tv4klive.com.</p>
                    </section>
                </div>
            </div>
        </main>
    );
}
